var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'table-graph':true,colours:!_vm.settings.hidden}},_vm._l((_vm.bars),function(bar,barIndex){return _c('span',{key:barIndex,class:{ 'bar': true, ['bar'+(barIndex+1)]: true },style:('height:'+bar.percent+'%'),attrs:{"title":_vm.barTitle(bar)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }